export default __webpack_public_path__ + "static/scalpel-and-heating-pen-a74e6312f3fa9e7d106d233bedb8bfc7.png";